export const UPDATE_SELECTED_ROLES = 'UPDATE_SELECTED_ROLES';
export const REMOVE_UNSELECTED_ROLES = 'REMOVE_UNSELECTED_ROLES';
export const CLEAR_SELECTED_ROLES = 'CLEAR_SELECTED_ROLES';

export const updateSelectedRoles = (data) => ({
  type: UPDATE_SELECTED_ROLES,
  payload: data,
});

export const removeUnSelectedRoles = (data) => ({
  type: REMOVE_UNSELECTED_ROLES,
  payload: data,
});

export const clearSelectedRoles = () => ({
  type: CLEAR_SELECTED_ROLES,
});
